export const paginationStyles = {
  // px: 4,
  alignItems: 'center',
  justifyContent: 'flex-end',
};
